/**
 * @file   src\Pages\Locations.tsx
 * @brief  Locations page.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { React, Button, useNavigate, useParams, useState, useEffect, useLocation } from "../utils/thirdpartyComponents";
import { pageURLs } from 'src/utils/pageUrls';
import "src/styles/inner-page-styles.scss";
import Advertisement from "./Advertisement";
import { MessageToaster } from "src/utils/toastUtil";
import { BayApi } from "src/utils/apiUrls";
import axios from '../config/axiosConfig';
import { BAY_AVAILABLE, BAY_BUSY, BAY_OUT_OF_SERVICE, BAY_QUEUE } from "src/utils/constants";
import PaymentfailModal from "../components/PaymentfailModal";
import SmallLoader from '../components/SmallLoader';
import { getFromLocalStorage } from "src/utils/helper";
import { CommonMessages } from 'src/messages/validationMessages';
import { bayTypeLabelMap, EquipmentTypeId } from "src/utils/enums";

const ScannerBusy = () => {
  const navigate = useNavigate();
  // Route information variable
  const params = useParams();
  // Instantiate MessageToaster
  const toaster = new MessageToaster();

  const [loading, setLoading] = useState(false);
  const [tryAgainButtonDisbaleStatus, setTryAgainButtonDisbaleStatus] = useState(false);
  const [showPaymentfailModal, setShowPaymentfailModal] = useState(false);
  const handleClosePaymentfailModal = () => setShowPaymentfailModal(false);
  const handleShowPaymentfailModal = () => setShowPaymentfailModal(true);
  const selectedBay = localStorage.getItem('selectedBay');

  const location = useLocation();
  const washName = location?.state?.washName
  const bayName = location?.state?.bayName;
  const bayNumber=location?.state?.bayNumber;
  const bayTypeID=location?.state?.bayTypeID
  const bayNameText = location?.state?.bayNameText;
  const queryParams = new URLSearchParams(location.search);
  const scanAction = (queryParams.get('scan') ==='true') ?  true  : false;
  const washType = (queryParams.get('washType') === "1" || queryParams.get('washType') === "2" || queryParams.get('washType') === "3") ?  queryParams.get('washType')  : 2;
  const isBayTunnel = (queryParams.get('isBayTunnel') =='false' ) ?  false  : true;

  const OkbuttonClick = () => {
    navigate("/" + params.carwashname + "/" + pageURLs.home);
  };

  const tryAgainbuttonclick = async (washType) => {
    if(!isBayTunnel)
    {
      navigate(-1);
    }
    else if (selectedBay) {
      // API call to get bay status
      try {
        setLoading(true); // Show loader
        setTryAgainButtonDisbaleStatus(true)
        let param = '';
        param += selectedBay;
        const geo_location = getFromLocalStorage('geolocation');
        const timezoneOffset = (new Date()).getTimezoneOffset();
        if (geo_location?.lat && geo_location?.long || scanAction) {
          const { data } = await axios.get(BayApi.GET_BAY_STATUS + param, {
            params: {
              lat: geo_location?.lat,
              lng: geo_location?.long,
              subType : washType, //(1== single wash, 2 == subscription)
              scan: (scanAction) ? 1 : 0,
              offset: timezoneOffset,
            }
          });
          // const { data } = await axios.get(BayApi.GET_BAY_STATUS+param);
          if (data.error === 0) {
            setTimeout(() => {
              setTryAgainButtonDisbaleStatus(false)
            }, 1000);
           if(data.data.bayOpen === false)
            {
                localStorage.removeItem('selectedBay')
                toaster.toastError(CommonMessages.bay_closed)
                navigate("/" + params.carwashname+ "/" + pageURLs.home );
            } 
            else if (data.data.deviceStatus === false) {
              navigate("/" + params.carwashname + "/" + pageURLs.statusoutofservice);
            }
            else if (data.data.subscription === false) {
              navigate(`/${params.carwashname}/${pageURLs.subscriptionandwashprice}?showSingleWash=true`);
              // navigate("/"+params.carwashname+"/"+pageURLs.subscriptionandwashprice, { state: { showSingleWash: true } });
            }
            else if(data.data.dailyWashLimitReached === true)
            {
                toaster.toastError(CommonMessages.exp_today_subscription);
                navigate("/" + params.carwashname+ "/" + pageURLs.home );
                
            }
            else if(data.data.washPackageError === true)
              {
                  toaster.toastError(CommonMessages.washPackageError);
                  navigate("/" + params.carwashname+ "/" + pageURLs.home );
              }
            else if(data.data.washCategoryError === true)
              {
                  toaster.toastError(CommonMessages.washCategoryError);
                  navigate("/" + params.carwashname+ "/" + pageURLs.home );
              }
            else {
              if (data.data.washRemaining <= 0 && data.data.isUnlimitedWash  == 0) {
                toaster.toastError(CommonMessages.no_wahses_remaining);
                navigate(`/${params.carwashname}/${pageURLs.subscriptionandwashprice}?showSingleWash=true&fromTab=singlewash`, { state: { bayId: selectedBay ? selectedBay : "" } });
              }
              else if (data.data.bayStatus === BAY_AVAILABLE) {
                navigate("/" + params.carwashname + "/" + pageURLs.statussuccess+"?washType="+washType, { state: { bayStatusSuccess: true ,washName:washName,bayName: data.data.bayName,bayNumber:data.data.bayNumber,bayTypeID:data.data.bayTypeID } });
              }
              else if (data.data.bayStatus === BAY_QUEUE) {
                navigate("/" + params.carwashname + "/" + pageURLs.scannerque+`?scan=`+scanAction+"&washType="+washType, { state: { selectedBayId: selectedBay,washName:washName,bayNumber:data.data.bayNumber,bayTypeID:data.data.bayTypeID } });
              }
              else if (data.data.bayStatus === BAY_BUSY) {
                navigate("/" + params.carwashname + "/" + pageURLs.statusbusy+`?scan=`+scanAction+"&washType="+washType, { state: { selectedBayId: selectedBay,washName:washName,bayNumber:data.data.bayNumber,bayTypeID:data.data.bayTypeID  }  });
              }
              else if (data.data.bayStatus === BAY_OUT_OF_SERVICE) {
                navigate("/" + params.carwashname + "/" + pageURLs.statusoutofservice);
              }
              else if (data.data.paymentStatus === false && data.data.deviceStatus === true && data.data.subscription === false) {
                handleShowPaymentfailModal();
              }
              else {
                navigate("/" + params.carwashname + "/" + pageURLs.statusoutofservice);
              }
            }
          }
          else {
            if (data.data.paymentStatus === false && data.data.deviceStatus === false && data.data.subscription === false) {
              handleShowPaymentfailModal();
            }
            else {
              // show error message
              toaster.toastError(data.message);
            }
          }
        }
        else{
          toaster.toastError(CommonMessages.no_loc_permission);
        }
      } catch (error: any) {
        throw new Error(error.response?.data?.message || error.message);
      } finally {
        setLoading(false); // Hide loader
      }

    }
    else {
      navigate("/" + params.carwashname + "/" + pageURLs.home);
    }
    // setShowad(true);
  };
 function getBayLabel(bayName:string,bayNumber:number,bayTypeID:number): any {
    if (bayName) return bayName;
    if (bayTypeID && bayNumber) {
      return `${bayTypeLabelMap[bayTypeID] || "Unknown"} ${bayNumber}`;
    }
    return "Unknown";
  }

  return (

    <div className="common-content-wrap pb-184">
      <div className="inner-content-wrap signup-block">
        <div className="common-header">
          <div className="pe-4 ps-4 pt-0 pb-0 h-100">
            <div className="common-header-inner">Bay Status</div>
          </div>
        </div>
        <div className="main-content-wrap pe-0 ps-0 pt-0">
        <div className="scanner-status-wrap position-relative">
        {/* <h5 className="mb-4 text-capitalize" > {washName}</h5> */}
         <div className="bay-title d-flex flex-column" >
              <p className="fw-bold m-0">Bay name: {bayNameText? bayNameText :getBayLabel(bayName,bayNumber,bayTypeID)}</p>
            <p className="fw-bold m-0">{bayTypeID==EquipmentTypeId.Vacuum? "Vacuum name":"Wash name" }: {washName}</p>
          </div>
            <div className="status-img-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" width="123.005" height="167.576" viewBox="0 0 123.005 167.576"><g transform="translate(-128.995 -176.661)"><path d="M58.814,5A53.54,53.54,0,0,0,28.73,14.188a53.986,53.986,0,0,0-19.5,23.681A53.737,53.737,0,0,0,14.188,88.9a53.986,53.986,0,0,0,23.681,19.5,53.737,53.737,0,0,0,51.03-4.961A53.986,53.986,0,0,0,108.4,79.76a53.737,53.737,0,0,0-4.961-51.03A53.986,53.986,0,0,0,79.76,9.227,53.472,53.472,0,0,0,58.814,5m0-5A58.814,58.814,0,1,1,0,58.814,58.814,58.814,0,0,1,58.814,0Z" transform="translate(128.995 226.608)" fill="#fc0" /><ellipse cx="7.224" cy="7.224" rx="7.224" ry="7.224" transform="translate(157.56 266.009)" fill="#fc0" /><circle cx="6.772" cy="6.772" r="6.772" transform="translate(204.513 266.009)" fill="#fc0" /><g transform="translate(184.074 220.984) rotate(-90)"><path d="M10.765,5.211a11.04,11.04,0,0,0,5.554,5.554,11.04,11.04,0,0,0-5.554,5.554,11.04,11.04,0,0,0-5.554-5.554,11.04,11.04,0,0,0,5.554-5.554m0-5.211A10.386,10.386,0,0,1,0,10.765,10.386,10.386,0,0,1,10.765,21.53,10.386,10.386,0,0,1,21.53,10.765,10.386,10.386,0,0,1,10.765,0Z" transform="translate(0 41.019)" fill="#fc0" /><path d="M5.636,0A5.438,5.438,0,0,1,0,5.636a5.438,5.438,0,0,1,5.636,5.636,5.438,5.438,0,0,1,5.636-5.636A5.438,5.438,0,0,1,5.636,0Z" transform="translate(18.77 0)" fill="#fc0" /></g><path d="M3,1A2,2,0,1,0,5,3,2,2,0,0,0,3,1M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z" transform="translate(203 187)" fill="#fc0" /><path d="M5,1A4,4,0,1,0,9,5,4,4,0,0,0,5,1M5,0A5,5,0,1,1,0,5,5,5,0,0,1,5,0Z" transform="translate(218 189)" fill="#fc0" /><path d="M2.5,1A1.5,1.5,0,1,0,4,2.5,1.5,1.5,0,0,0,2.5,1m0-1A2.5,2.5,0,1,1,0,2.5,2.5,2.5,0,0,1,2.5,0Z" transform="translate(201 201)" fill="#fc0" /><path d="M5.5,2A3.5,3.5,0,1,0,9,5.5,3.5,3.5,0,0,0,5.5,2m0-2A5.5,5.5,0,1,1,0,5.5,5.5,5.5,0,0,1,5.5,0Z" transform="translate(241 227)" fill="#fc0" /><g transform="translate(204.124 157.508) rotate(45)"><path d="M7.712-.5a.894.894,0,0,1,.893.893c0,2.852.349,4.365,1.2,5.22s2.368,1.2,5.22,1.2a.893.893,0,1,1,0,1.787c-2.852,0-4.365.349-5.22,1.2s-1.2,2.368-1.2,5.221a.893.893,0,0,1-1.787,0c0-2.853-.349-4.365-1.2-5.221s-2.368-1.2-5.22-1.2a.893.893,0,1,1,0-1.787c2.852,0,4.365-.349,5.22-1.2s1.2-2.368,1.2-5.22A.894.894,0,0,1,7.712-.5Zm4.926,8.212A5.661,5.661,0,0,1,9.1,6.321,5.661,5.661,0,0,1,7.712,2.786,5.661,5.661,0,0,1,6.321,6.321,5.661,5.661,0,0,1,2.786,7.712,5.661,5.661,0,0,1,6.321,9.1a5.662,5.662,0,0,1,1.391,3.535A5.662,5.662,0,0,1,9.1,9.1,5.661,5.661,0,0,1,12.638,7.712Z" transform="translate(0 55.649)" fill="#fc0" /><path d="M4.229,8.459a.394.394,0,0,1-.393-.393c0-2.863-.579-3.442-3.442-3.442a.393.393,0,1,1,0-.787c2.863,0,3.442-.579,3.442-3.442a.393.393,0,0,1,.787,0c0,2.863.579,3.442,3.442,3.442a.393.393,0,1,1,0,.787c-2.863,0-3.442.579-3.442,3.442a.394.394,0,0,1-.393.393ZM3.009,4.229a2.288,2.288,0,0,1,1.22,1.22,2.288,2.288,0,0,1,1.22-1.22,2.288,2.288,0,0,1-1.22-1.22A2.288,2.288,0,0,1,3.009,4.229Z" transform="translate(27.086 0)" fill="#fc0" /></g><path d="M2.135,2.737a60.8,60.8,0,0,1,15.187.139c4.813.735-.829-3.046-8.305-2.871S.11,2.452.11,2.452-.712,3.278,2.135,2.737Z" transform="matrix(-0.777, 0.629, -0.629, -0.777, 215.582, 258.068)" fill="#fc0" /><path d="M1.706,2.459a43.27,43.27,0,0,1,12.137.125c3.846.66-.663-2.736-6.637-2.579S.088,2.2.088,2.2-.569,2.945,1.706,2.459Z" transform="translate(172.108 269.109) rotate(-137)" fill="#fc0" /><path d="M493.756-134.013a31.15,31.15,0,0,1,11.615,2.554,24.858,24.858,0,0,0,8.919,2.177,8.508,8.508,0,0,0,4.9-1.443,5.6,5.6,0,0,1,2.892-1.038,3.639,3.639,0,0,1,1.516.336,2.874,2.874,0,0,1,1.533,1.657,3.449,3.449,0,0,1,.087,1.914c-.425,1.96-2.367,4.336-5.066,6.2a18.687,18.687,0,0,1-10.5,3.348,17.54,17.54,0,0,1-3.71-.4,86.9,86.9,0,0,1-8.782-2.435c-2.818-.907-4.854-1.563-7.166-1.563h0a16.178,16.178,0,0,0-3.955.545,7,7,0,0,1-2.084.353,3.6,3.6,0,0,1-3.535-2.275,5.316,5.316,0,0,1,1.291-5.346l.134-.124a15.439,15.439,0,0,1,3.748-2.641A18.012,18.012,0,0,1,493.756-134.013Zm20.535,8.732a28.269,28.269,0,0,1-10.427-2.472,27.221,27.221,0,0,0-10.107-2.259,12.61,12.61,0,0,0-9.185,3.391l-.154.142a1.7,1.7,0,0,0-.248.659,4.1,4.1,0,0,0,.722-.169l.056-.018.057-.014A20.166,20.166,0,0,1,490-126.7h0c2.939,0,5.345.775,8.391,1.755a82.326,82.326,0,0,0,8.4,2.333,13.531,13.531,0,0,0,2.862.309,14.743,14.743,0,0,0,8.388-2.755,13.563,13.563,0,0,0,1.674-1.394A12.152,12.152,0,0,1,514.29-125.281Z" transform="translate(-314.922 430.845)" fill="#fc0" /></g></svg>
            </div>
            <h2>Busy!</h2>
            <p>The selected bay is busy now.<br />Please wait for the bay to be available.</p>

          </div>
        </div>
      </div>
      <div className="btm-secondarybtn-wrap">
        <div className="btm-inner-wrap">
          <Button variant="secondary" className="secondary-btn btn-main" onClick={() => tryAgainbuttonclick(washType)} disabled={tryAgainButtonDisbaleStatus}>Try Again</Button>
        </div>
      </div>
      <div className="btm-wrap">
        <div className="btm-inner-wrap">
          <Button variant="primary" className="primary-btn btn-main" onClick={OkbuttonClick}>Exit</Button>
        </div>
      </div>
      {loading && <SmallLoader />}

      {/* comment for now only (dummy data)  */}
      <Advertisement />

      <PaymentfailModal
        show={showPaymentfailModal}
        onHide={handleClosePaymentfailModal}
      />
    </div>

  )
}

export default ScannerBusy;
